/***
 * 创建人：张丽莉
 * 时间：2019-06-11
 * 描述: 自定义导出全局列
 * 使用说明: 
 * 更新说明:
 */
import { Component, OnInit,Input,AfterViewInit } from '@angular/core';
declare var $: any;
@Component({
  selector: 'sw-export-global',
  templateUrl: './sw-export-global.component.html',
  styleUrls: ['./sw-export-global.component.css']
})
export class SwExportGlobalComponent implements OnInit ,AfterViewInit{
  @Input() datas: any = []; //自定义导出项按钮数据
  @Input() ids: any = []; //选中的ids数组集合
  constructor() { }
 //选中值导出项有默认值  当重置时  选中的为默认值
 selectedInt:any=[]
 selected:any=[];
 
  ngOnInit() {
    this.selectInt();
  }

  selectInt(){
    this.selected = []
    this.selectedInt.forEach(element => {
      this.selected.push(element)
    });
  }

  ngAfterViewInit(){
    this.choiceItem();
   }

  //对已选中的div添加class名 choice
  choiceItem(){
    this.clearClass();
    let $export =$(".export-global")
    for(let i=0;i<$export.length;i++){
      let index = i;
      let $html=$export.eq(i).find("span").html();
       for(let j=0;j<this.selected.length;j++){
          if($html == this.selected[j].description){
            $export.eq(index).find("div").addClass('choice')
          }
       }
    }
  }

   //清空样式
   clearClass(){
    let $export1 =$(".export-global");
    for(let i=0;i<$export1.length;i++){
      $export1.eq(i).find("div").removeClass('choice')
    }
  }

  //选中列表事件
  checkExportItem(data,indexNum) {
    let $export =$(".export-global");
    let $num = 0;
    this.selected.forEach((val,index) => {
      if(val.name == data.name){
        $num =1;
        this.selected.splice(index,1);
        $export.eq(indexNum).find('div').removeClass('choice')
      }
    });
    if($num == 0){
      this.selected.push(data);
      $export.eq(indexNum).find("div").addClass('choice')
    }
  }

 //全选/反选事件
  clickChecedAll() {
    this.selected = []
    let br = $("#CheAll")[0].checked;
    //全选
    if(br){
      this.datas.forEach(element => {
        this.selected.push(element)
      });
      this.choiceItem();
    }else{
      //反选
      this.choiceItem()
    }
  }

  //重置
  clickReset(){
    this.selectInt();
    $("#CheAll").prop("checked", false);
    this.choiceItem()
  }
  
  //格式化导出值
  getData(){
    let arr = [];
    let arr1=[];
    this.selected.forEach(val=>{
      arr.push(val.name)
    })
    let str = arr.join(',');
    this.ids.forEach(ele=>{
      let obj={id:ele,fieldName:str};
      arr1.push(obj)
    })
    return arr1;
  }

}
